
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"19","viewBox":"0 0 22 19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.47218 18.0971L0.322184 10.2971C-0.107374 9.82845 -0.107374 9.06865 0.322184 8.6L1.87778 6.90293C2.30734 6.43428 3.00386 6.43428 3.43342 6.90293L8.25 12.1573L18.5666 0.90294C18.9961 0.434331 19.6927 0.434331 20.1222 0.90294L21.6778 2.6C22.1074 3.06861 22.1074 3.82841 21.6778 4.29706L9.02782 18.0971C8.59822 18.5657 7.90174 18.5657 7.47218 18.0971V18.0971Z","fill":"#000"}})])
          )
        }
      }
    